import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Tooltip } from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LinkIcon from '@material-ui/icons/Link';
import { socialTypes } from '../../../constants/consts';
import { addProtocolIfNeed } from '../../../utils/common';
import VkIcon from '../../../public/images/icons/vkicon.svg';
import VimeoIcon from '../../../public/images/icons/vimeo.svg';
import classes from './SocialIcons.module.scss';
import ImageTag from '../../ImageTag';

const SocialIcon = ({ type, url, iconClass, colored }) => {
  const icon = React.useCallback(() => {
    switch (type) {
      case socialTypes.FACEBOOK:
        return <FacebookIcon className={classes.socialIcon} />;
      case socialTypes.TWITTER:
        return <TwitterIcon className={classes.socialIcon} />;
      case socialTypes.INSTAGRAM:
        return <InstagramIcon className={classes.socialIcon} />;
      case socialTypes.LINKEDIN:
        return <LinkedInIcon className={classes.socialIcon} />;
      case socialTypes.YOUTUBE:
        return <YouTubeIcon className={classes.socialIcon} />;
      case socialTypes.VK:
        return <ImageTag src={VkIcon} className={classes.socialIcon} alt="VK Link" />;
      case socialTypes.VIMEO:
        return <ImageTag src={VimeoIcon} className={classes.socialIcon} alt="vimeo" />;
      default:
        return <LinkIcon className={classes.socialIcon} />;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return (
    <a
      href={addProtocolIfNeed(url)}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(classes.socialIconLink, { [classes[type]]: colored }, iconClass)}
    >
      <Tooltip title={type}>{icon()}</Tooltip>
    </a>
  );
};

SocialIcon.propTypes = {
  type: PropTypes.oneOf([...Object.values(socialTypes), 'other']),
  colored: PropTypes.bool,
  url: PropTypes.string,
};

SocialIcon.defaultProps = {
  colored: true,
};

export default SocialIcon;
